import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "../Components/ui/tooltip.js";
import { cn } from "../lib/utils.js";
const Actions = ({ className, children, ...props }) => /* @__PURE__ */ jsx("div", { className: cn("tw:inline-flex tw:items-center tw:gap-1 tw:rounded-[10px]", className), ...props, children });
const ACTION_BUTTON_SIZE_PX = 24;
const ACTION_ICON_SIZE_PX = 20;
const forceActionButtonLayout = (el) => {
  if (!el) return;
  el.style.setProperty("width", `${ACTION_BUTTON_SIZE_PX}px`, "important");
  el.style.setProperty("height", `${ACTION_BUTTON_SIZE_PX}px`, "important");
  el.style.setProperty("padding", "0", "important");
  el.style.setProperty("border", "none", "important");
  el.style.setProperty("box-sizing", "border-box", "important");
  const svg = el.querySelector("svg");
  if (svg) {
    svg.style.setProperty("width", `${ACTION_ICON_SIZE_PX}px`, "important");
    svg.style.setProperty("height", `${ACTION_ICON_SIZE_PX}px`, "important");
    svg.style.setProperty("flex-shrink", "0", "important");
  }
};
const Action = ({ tooltip, children, label, className, tooltipOpen, ...props }) => {
  const [hovered, setHovered] = useState(false);
  const prevTooltipOpenRef = useRef(tooltipOpen);
  useEffect(() => {
    if (prevTooltipOpenRef.current === true && !tooltipOpen) {
      setHovered(false);
    }
    prevTooltipOpenRef.current = tooltipOpen;
  }, [tooltipOpen]);
  const isOpen = tooltipOpen || hovered;
  const button = /* @__PURE__ */ jsxs(
    "button",
    {
      ref: forceActionButtonLayout,
      className: cn(
        "tw:flex tw:items-center tw:justify-center tw:w-6 tw:h-6 tw:min-w-0 tw:min-h-0 tw:cursor-pointer tw:rounded-[5px] tw:bg-transparent tw:border-none tw:p-0 tw:text-current tw:hover:bg-[#F7F8FA] tw:transition-colors tw:[&_svg]:w-5 tw:[&_svg]:h-5 tw:[&_svg]:shrink-0",
        className
      ),
      type: "button",
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx("span", { className: "tw:sr-only", children: label || tooltip })
      ]
    }
  );
  if (tooltip) {
    return /* @__PURE__ */ jsx(TooltipProvider, { delayDuration: 200, children: /* @__PURE__ */ jsxs(Tooltip, { open: isOpen, children: [
      /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: button }),
      /* @__PURE__ */ jsx(TooltipContent, { side: "bottom", children: /* @__PURE__ */ jsx("p", { children: tooltip }) })
    ] }) });
  }
  return button;
};
export {
  Action,
  Actions
};
//# sourceMappingURL=actions.js.map
